"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var availability_1 = __importDefault(require("../../../config/availability"));
var normalizeCarouselMedia_1 = __importDefault(require("./normalizeCarouselMedia"));
var normalizeSkus = function (products) {
    var skus = products.map(function (product) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        var renderKey = product.use_render_of || product.id;
        return {
            id: product.id,
            name: product.name,
            sku: product.sku,
            shoppingName: product.shoppingName,
            brand: product.brand,
            productKey: product.product_key,
            render: product.have_render ? renderKey : null,
            hoverRender: !product.no_hover_render ? "".concat(renderKey, "_hover") : null,
            invisible: product.invisible,
            isNew: product.isNew,
            shoppingBadge: product.shoppingBadge
                ? {
                    url: (_a = product.shoppingBadge) === null || _a === void 0 ? void 0 : _a.url,
                }
                : null,
            complianceImage: product.compliance_image,
            complianceDoc: product.compliance_doc,
            availability: {
                daysDelayed: (_b = product.availability) === null || _b === void 0 ? void 0 : _b.days_delayed,
                noInventory: (_c = product.availability) === null || _c === void 0 ? void 0 : _c.no_inventory,
                status: (_d = product.availability) === null || _d === void 0 ? void 0 : _d.availability_status,
                availableOnSec: (_e = product.availability) === null || _e === void 0 ? void 0 : _e.available_on_sec,
                oneDayShipping: (_f = product.availability) === null || _f === void 0 ? void 0 : _f.one_day_shipping,
                twoDayShipping: (_g = product.availability) === null || _g === void 0 ? void 0 : _g.two_day_shipping,
                canBuy: ((_h = product.availability) === null || _h === void 0 ? void 0 : _h.availability_status) !==
                    availability_1.default.SOLD_OUT_STATUS &&
                    ((_j = product.availability) === null || _j === void 0 ? void 0 : _j.availability_status) !==
                        availability_1.default.BY_PREORDER_STATUS &&
                    ((_k = product.availability) === null || _k === void 0 ? void 0 : _k.availability_status) !==
                        availability_1.default.COMING_SOON_STATUS &&
                    ((_l = product.availability) === null || _l === void 0 ? void 0 : _l.availability_status) !==
                        availability_1.default.UNAVAILABLE_STATUS,
            },
            includesBase: product.includes_base,
            includesProflector: product.includes_proflector,
            basesIncluded: product.bases_included && !!Object.keys(product.bases_included).length
                ? product.bases_included
                : null,
            gamesIncluded: product.games_included && !!Object.keys(product.games_included).length
                ? product.games_included
                : null,
            subscriptionsIncluded: product.subscriptions_included && product.subscriptions_included.length
                ? product.subscriptions_included
                : null,
            storageIncluded: product.storage_included &&
                !!Object.keys(product.storage_included).length
                ? product.storage_included
                : null,
            marketedGamesIncluded: product.marketed_games_included &&
                !!Object.keys(product.marketed_games_included).length
                ? product.marketed_games_included
                : null,
            includedAppsToShowcase: product.included_apps_to_showcase &&
                !!Object.keys(product.included_apps_to_showcase).length
                ? product.included_apps_to_showcase
                : null,
            requiredHardware: product.required_hardware,
            groupOf: product.group_of && !!Object.keys(product.group_of).length
                ? product.group_of
                : null,
            orderLimit: product.order_limit,
            isAccessory: product.is_accessory,
            isKit: product.is_kit,
            isDigitalOnly: product.isDigitalOnly,
            isSubscription: product.is_subscription,
            subscriptionType: product.subscription_type,
            subscriptionFrequency: product.subscription_frequency,
            isBase: product.single_item_sku && product.includes_base,
            isGameSystem: product.is_game_system,
            isPlayosmoExclusive: product.isPlayosmoExclusive,
            isFireProflectorIncompatible: product.fire_proflector_incompatible,
            isSkuDisplayedOnFrontend: product.display_sku_frontend,
            singleItemSku: product.single_item_sku,
            price: {
                currency: (_o = (_m = product.price) === null || _m === void 0 ? void 0 : _m.currency) === null || _o === void 0 ? void 0 : _o.toUpperCase(),
                discountedPrice: (_p = product.price) === null || _p === void 0 ? void 0 : _p.discounted_price,
                originalPrice: (_q = product.price) === null || _q === void 0 ? void 0 : _q.original_price,
                recurringPrice: (_r = product.price) === null || _r === void 0 ? void 0 : _r.recurring_price,
            },
            ratings: {
                overallRating: (_s = product.ratings) === null || _s === void 0 ? void 0 : _s.overall_rating,
                star1: (_t = product.ratings) === null || _t === void 0 ? void 0 : _t.star_1,
                star2: (_u = product.ratings) === null || _u === void 0 ? void 0 : _u.star_2,
                star3: (_v = product.ratings) === null || _v === void 0 ? void 0 : _v.star_3,
                star4: (_w = product.ratings) === null || _w === void 0 ? void 0 : _w.star_4,
                star5: (_x = product.ratings) === null || _x === void 0 ? void 0 : _x.star_5,
            },
            images: product.images,
            carouselMedia: product.carousel_medias
                ? (0, normalizeCarouselMedia_1.default)(product.carousel_medias)
                : null,
        };
    });
    return skus;
};
exports.default = normalizeSkus;
